import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { url: { type: String } };

  static targets = ['code', 'prefecture', 'city', 'town', 'prefecture_en', 'city_en', 'town_en', 'address'];

  handleClickAutocompleteAddress() {
    this.updateAddressFields();
  }

  updateAddressFields() {
    const code = this.codeTarget.value;
    if (!code) { return; }
    const url = this.urlValue;
    const params = new URLSearchParams({ code });

    fetch(`${url}?${params}`).then((response) => {
      if (response.status === 200) {
        response.json().then((json) => {
          this.constructor.targets.forEach((attr) => {
            if (this[`has${attr[0].toUpperCase() + attr.slice(1)}Target`]) {
              this[`${attr}Target`].value = json[`${attr}`];
            }
          });
        });
      }
    });
  }
}
